import React, { FC } from 'react';
import { FormControl, Select, MenuItem, SelectChangeEvent, InputLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { UserType } from 'models/user';

type UserTypeFilterProps = {
    value: UserType;
    onTypeSelect: (type: UserType) => void;
    fullWidth?: boolean;
};

const UserTypeFilter: FC<UserTypeFilterProps> = ({ value, onTypeSelect, fullWidth }) => {
    const { t } = useTranslation(['common', 'users']);

    const handleChange = (event: SelectChangeEvent<UserType>) => {
        onTypeSelect(event.target.value as UserType);
    };

    return (
        <FormControl margin="dense" fullWidth={fullWidth} sx={{ minWidth: 150 }}>
            <InputLabel id="user-type-label" shrink>
                {t('users:USER_TYPE')}
            </InputLabel>

            <Select
                labelId="user-type-label"
                value={value}
                displayEmpty
                renderValue={(selected: UserType) => {
                    if (selected === '') {
                        return t('common:SHOW_ALL');
                    }
                    if (selected === 'dentist') {
                        return t('users:DENTIST');
                    }
                    if (selected === 'lab_technician') {
                        return t('users:LAB_TECHNICIAN');
                    }
                    return '';
                }}
                label={t('users:USER_TYPE')}
                onChange={handleChange}
            >
                <MenuItem value="">{t('common:SHOW_ALL')}</MenuItem>
                <MenuItem value="dentist">{t('users:DENTIST')}</MenuItem>
                <MenuItem value="lab_technician">{t('users:LAB_TECHNICIAN')}</MenuItem>
            </Select>
        </FormControl>
    );
};

export default UserTypeFilter;
